import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=b056c816&lang=pug&"
import script from "./ActionCard.vue?vue&type=script&lang=ts&"
export * from "./ActionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports